import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';
import InputGroupV2 from '../InputGroupV2';

const DefaultSelectV2 = ({
  options,
  onSelect,
  value,
  error,
  helperText,
  label,
  isRequired,
  placement,
  title,
  useTooltip,
  name,
  disabled,
  showEmpty,
  optionLabel,
  handlerOption,
}) => {
  const defaultHelperText = helperText ? helperText : 'O campo é obrigatório';

  const stringValue =
    value === undefined || value === null ? '' : String(value);

  const handleChange = (event) => {
    onSelect(event);
  };

  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={isRequired}
    >
      <TextField
        fullWidth
        error={error}
        disabled={disabled}
        helperText={error ? defaultHelperText : ''}
        margin="dense"
        name={name}
        onChange={handleChange}
        select
        value={stringValue}
        variant="outlined"
        SelectProps={{
          displayEmpty: showEmpty,
        }}
        sx={{
          ...(!disabled && {
            '& .MuiInputBase-root': {
              bgcolor: 'background.paper',
            },
          }),
        }}
      >
        {showEmpty ? (
          <MenuItem value="">
            Selecione...
          </MenuItem>
        ) : null}
        {options.map((option) => (
          <MenuItem
            key={String(option.id)}
            value={String(option.id)}
          >
            {handlerOption(option, optionLabel)}
          </MenuItem>
        ))}
      </TextField>
    </InputGroupV2>
  );
};

DefaultSelectV2.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  isRequired: PropTypes.any,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  showEmpty: PropTypes.bool,
  optionLabel: PropTypes.string,
  handlerOption: PropTypes.func,
};

DefaultSelectV2.defaultProps = {
  error: false,
  helperText: null,
  value: '',
  placement: 'top',
  title: '',
  useTooltip: false,
  isRequired: false,
  label: '',
  name: '',
  disabled: false,
  showEmpty: true,
  optionLabel: 'nome',
  handlerOption: (option, optionLabel) => option[optionLabel],
};

export default DefaultSelectV2;
